// knowledgeDetails.pipeline.overview.* — owned by the overview page.
export default {
  loading: 'Loading knowledge base…',
  loadFailed:
    'Could not load this knowledge base. Reload the page to try again.',
  summary:
    '{{docs}} documents · {{chunks}} chunks in index · {{tokens}} tokens',
  lastRun: 'last run {{when}}',
  neverRun: 'never run',
  empty:
    'No documents yet. Add files in Documents or connect a source to start the pipeline.',
  stripHint:
    'click a stage title to expand it · pick a document above to trace its ribbon',
  focus: {
    label: 'Focus',
    all: 'All documents',
    group: 'Documents that need attention',
    option: '{{name}} ({{state}})',
    chunks: '{{n}} chunks',
    tokens: '{{n}} tokens',
    openChunks: 'Open its chunks',
  },
  band: '{{n}} {{state}}',
  docBand: '{{n}} · {{name}}',
  stats: {
    documents: 'documents',
    waiting: 'waiting',
    emptySources: 'empty files',
    latestRun: 'latest sync',
    hereNow: 'in progress',
    failedHere: 'failed here',
    chunks: 'chunks',
    tokens: 'tokens',
    searchable: 'searchable docs',
    graph: 'graph',
    built: 'built',
    notBuilt: 'not built',
    threshold: 'threshold',
    vector: 'vector weight',
    keyword: 'keyword weight',
  },
  subtitle: {
    local: 'Local uploads',
    method: 'Method {{method}}',
    chunkSize: '{{size}} tokens per chunk',
    model: '{{model}}',
    defaultModel: 'default chat model',
    index: 'Vector + keyword (BM25)',
    graphMethod: 'Method {{method}}',
    retrieve: 'threshold {{threshold}} · keyword {{keyword}}',
  },
  settings: {
    title: 'Settings',
    source: 'Source',
    documents: 'Documents',
    waiting: 'Waiting for Parse',
    emptySources: 'Empty files (0 bytes)',
    latestRun: 'Latest sync',
    latestRunError: 'Sync error',
    method: 'Chunk method',
    layout: 'Layout recognition',
    html4excel: 'Excel to HTML',
    chunkSize: 'Recommended chunk size',
    delimiter: 'Delimiter',
    autoKeywords: 'Auto keywords',
    autoQuestions: 'Auto questions',
    raptor: 'RAPTOR',
    llm: 'Model',
    documentCache: 'Use document cache',
    cacheStrategy: 'Cache strategy',
    maxCacheSize: 'Max cache size',
    batchSize: 'Batch size',
    embeddingModel: 'Embedding model',
    whyLocked:
      'Locked: {{chunks}} chunks are already embedded with it. Create a new knowledge base to switch.',
    chunks: 'Chunks in index',
    tokens: 'Tokens',
    useGraphrag: 'Extract knowledge graph',
    graphMethod: 'Method',
    entityTypes: 'Entity types',
    resolution: 'Entity resolution',
    community: 'Community reports',
    graphBuilt: 'Graph',
    threshold: 'Similarity threshold',
    vectorWeight: 'Vector similarity weight',
    keywordWeight: 'Keyword similarity weight',
    on: 'on',
    off: 'off',
    none: 'none',
  },
  documents: {
    title: 'Documents at this stage',
    none: 'No document is in progress or failed at this stage.',
    more: 'and {{count}} more',
    open: 'Open {{name}}',
    unknown:
      '{{count}} more failed or running documents are not shown; open Documents to see them all.',
  },
  actions: {
    resume: 'Resume {{count}} failed documents',
    resuming: 'Resuming…',
    retry: 'Retry stuck and failed documents',
    retrying: 'Retrying…',
    configure: 'Edit in Configuration',
  },
  links: {
    sources: 'Sync runs →',
    documents: 'Documents →',
    graph: 'Open the graph →',
    retrieval: 'Test a query →',
  },
  article: {
    title: 'How {{name}} is built',
    intro:
      'Every knowledge base is a pipeline. The strip above shows the stages this one runs, in order, with the documents that flow between them. Expand a stage to see its settings, the documents stopped in it and their real error lines.',
    wrongLabel: 'What can go wrong:',
    failedHere:
      '{{count}} documents stopped at this stage. The first error reads:',
    runningHere: '{{count}} documents are in this stage now.',
    nothingWrong: 'Nothing has failed at this stage.',
    sources:
      '{{total}} documents came in from {{source}}. {{pending}} are waiting for someone to press Parse.',
    parse:
      'Each file is read by Docling into text, tables and figures, using the {{method}} chunk method.',
    chunk:
      'The parsed text is cut into chunks that can be retrieved on their own. The knowledge base holds {{chunks}} chunks.',
    chunkWithSize:
      'The parsed text is cut into chunks of about {{size}} tokens that can be retrieved on their own. The knowledge base holds {{chunks}} chunks.',
    contextualise:
      '{{model}} reads the whole document and adds its context to the front of every chunk, so the chunk makes sense on its own. This stage bills an LLM, and changing it needs a re-parse.',
    embed:
      'Each chunk becomes a vector from {{model}}. The model is locked once chunks exist, because vectors from two models cannot be compared.',
    index:
      'Chunks and vectors are written to the search index, so a question can match on keywords (BM25) and on meaning (vector search).',
    graphrag:
      'An LLM extracts entities and relations from every chunk into a knowledge graph. This stage bills an LLM per chunk.',
    graphBuilt: 'The graph is built.',
    graphNotBuilt: 'No graph has been built yet.',
    retrieve:
      'A question runs as a hybrid search and is rescored as {{vector}} × vector similarity + {{keyword}} × keyword similarity. Chunks scoring under {{threshold}} are dropped. Settings tuned on the Retrieval page are not saved.',
    retrieveNoWeights:
      'A question runs as a hybrid search over keywords and vectors, and the best-scoring chunks are returned. Settings tuned on the Retrieval page are not saved.',
  },
};
